import { wrapRootElement as wrap } from './src/components/global/MDX-root-wrapper';

require('./src/styles/main.scss');

export const wrapRootElement = wrap;
